import Vue from 'vue';
import Vuex from 'vuex';
import app from './modules/app';
import appStore from './modules/appStore';
import user from './modules/user';
import ringtone from './modules/ringtone/index';
import introduce from './modules/introduce';
import getters from './getters';
import diy from './modules/diy';
import miguBJYH from './modules/miguBJYH';
import customSdk from './modules/customSdk';
import search from './modules/search';
import categories from './modules/categories';
Vue.use(Vuex);
export default new Vuex.Store({
    state: {},
    mutations: {},
    actions: {},
    getters,
    modules: {
        app,
        user,
        diy,
        introduce,
        search,
        appStore,
        categories,
        ringtone,
        miguBJYH,
        customSdk
    }
});
